import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'

class SelectComponent extends React.Component {
  render() {
    const list = [<option key="dummy" value=""></option>]
    // eslint-disable-next-line

    // eslint-disable-next-line no-unused-vars
    if (this.props.options) {
      for (const [index, opt] of this.props.options.entries()) {
        let matched = false
        if (this.props.dataField === 'organization' && !matched) {
          matched = !false
          list.push(
            <option
              key={this.props.dataField + opt.organization_code + index}
              value={opt.organization_code}
            >
              {opt.organization_code}
            </option>
          )
        }
        if (opt.display_text && opt.key && !matched) {
          matched = !false
          list.push(
            <option key={opt.key} value={opt.key}>
              {opt.display_text}
            </option>
          )
        }
        if (opt.text && !matched) {
          matched = !false
          list.push(
            <option key={this.props.dataField + opt.value} value={opt.value}>
              {opt.text}
            </option>
          )
        }
        if (!matched) {
          list.push(
            <option key={this.props.dataField + opt} value={opt}>
              {opt}
            </option>
          )
        }
      }
    }

    return (
      <ReactBootstrap.Form.Group
        key={'grp' + this.props.dataField}
        controlId={this.props.dataField}
      >
        <ReactBootstrap.Form.Label key={'lbl' + this.props.dataField}>
          {this.props.text}
        </ReactBootstrap.Form.Label>
        {this.props.searchFieldKey ? (
          <ReactBootstrap.Form.Control
            key={this.props.dataField}
            onChange={this.props.onChange}
            name={this.props.searchFieldKey}
            as="select"
            placeholder={'Enter ' + this.props.text}
          >
            {list}
          </ReactBootstrap.Form.Control>
        ) : (
          <ReactBootstrap.Form.Control
            key={this.props.dataField}
            onChange={this.props.onChange}
            name={this.props.dataField}
            as="select"
            placeholder={'Enter ' + this.props.text}
          >
            {list}
          </ReactBootstrap.Form.Control>
        )}
      </ReactBootstrap.Form.Group>
    )
  }
}

export class GenericSearchForm extends React.Component {
  constructor(props) {
    super(props)
    this.columns = props.columns
    this.state = { ...props.initData }
    this.mySubmitHandler = this.mySubmitHandler.bind(this)
    this.myChangeHandler = this.myChangeHandler.bind(this)
    this.onSubmit = this.props.onFilter
    this.reset = this.reset.bind(this)
  }
  reset(event) {
    event.preventDefault()
    const keys = Object.keys(this.state)
    let obj = {}
    keys.forEach((key) => {
      obj[key] = ''
    })
    this.setState(obj, () => {
      this.onSubmit(this.state)
    })
  }
  mySubmitHandler(event) {
    event.preventDefault()
    this.onSubmit(this.state)
  }
  myChangeHandler(event) {
    this.setState({ [event.target.name]: event.target.value }, () => {})
  }
  render() {
    const controls = []
    // eslint-disable-next-line
    for (const [index, value] of this.columns.entries()) {
      if (!value.searchFieldType) {
        continue
      }
      if (
        value.searchFieldType !== 'select' &&
        value.searchFieldType !== 'date'
      )
        controls.push(
          <ReactBootstrap.Form.Group
            key={'grp' + value.dataField}
            controlId={value.dataField}
          >
            <ReactBootstrap.Form.Label key={'Label' + value.dataField}>
              {value.text}
            </ReactBootstrap.Form.Label>
            {value.searchFieldKey ? (
              <ReactBootstrap.Form.Control
                name={value.searchFieldKey}
                key={value.dataField}
                value={this.state[value.dataField]}
                onChange={this.myChangeHandler}
                type={value.searchFieldType}
                placeholder={'Enter ' + value.text}
              />
            ) : (
              <ReactBootstrap.Form.Control
                name={value.dataField}
                key={value.dataField}
                value={this.state[value.dataField]}
                onChange={this.myChangeHandler}
                type={value.searchFieldType}
                placeholder={'Enter ' + value.text}
              />
            )}
          </ReactBootstrap.Form.Group>
        )
      if (value.searchFieldType === 'select')
        controls.push(
          <SelectComponent
            key={'select_cmp' + value.dataField}
            onChange={this.myChangeHandler}
            {...value}
          />
        )
      if (value.searchFieldType === 'date')
        controls.push(
          <ReactBootstrap.Row>
            <ReactBootstrap.Col>
              <ReactBootstrap.Form.Label key={'Label' + value.dataField}>
                {value.text} After
              </ReactBootstrap.Form.Label>
              <ReactBootstrap.Form.Control
                name={`${value.dataField}_after`}
                key={value.dataField}
                value={this.state[`${value.dataField}_after`]}
                onChange={this.myChangeHandler}
                type={value.searchFieldType}
                placeholder={'Enter ' + value.text}
              />
              <ReactBootstrap.Form.Label key={'Label' + value.dataField}>
                {value.text} Before
              </ReactBootstrap.Form.Label>
              <ReactBootstrap.Form.Control
                name={`${value.dataField}_before`}
                key={value.dataField}
                value={this.state[`${value.dataField}_before`]}
                onChange={this.myChangeHandler}
                type={value.searchFieldType}
                placeholder={'Enter ' + value.text}
              />{' '}
            </ReactBootstrap.Col>
          </ReactBootstrap.Row>
        )
    }
    return (
      <ReactBootstrap.Form onSubmit={this.mySubmitHandler}>
        {controls}
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6} className="text-left">
            <br />
            <ReactBootstrap.Button
              variant="link"
              className="btn text-dark btn-sm"
              type="button"
              onClick={this.reset}
            >
              Clear
            </ReactBootstrap.Button>
          </ReactBootstrap.Col>
          <ReactBootstrap.Col xs={6} className="text-end text-dark">
            <br />
            <ReactBootstrap.Button
              variant="outline-dark"
              size="sm"
              type="submit"
            >
              Submit
            </ReactBootstrap.Button>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Form>
    )
  }
}
